import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { Asterisk, Inner, Label, Message, Outer, SelectField } from './select.styles';
export default function Select({ name, children, label, options, control, rules, isRequired = false, shouldUnregister, ...selectProps }) {
    const { field, fieldState: { error }, } = useController({
        name,
        control,
        rules,
        shouldUnregister,
    });
    return (_jsxs(Outer, { children: [_jsxs(Inner, { children: [_jsxs(Label, { htmlFor: label, children: [children ?? label, isRequired && _jsx(Asterisk, { children: "*" })] }), _jsxs(SelectField, { ...selectProps, defaultValue: field.value ?? 0, onBlur: field.onBlur, onChange: field.onChange, isError: !!error, ref: field.ref, children: [_jsx("option", { value: 0, disabled: true, children: selectProps.placeholder }), options.map((o) => (_jsx("option", { value: o.value, children: o.label }, o.label + o.value)))] })] }), !!error && _jsx(Message, { children: error.message })] }));
}
